module.exports = __webpack_public_path__ + "img/car_00027.7c991832.jpg";